<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="19210"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        />
        <div style="flex-grow: 1;min-height: 350px;">
          <cargo-ag-grid-wrapper
            config-module="202506071"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="202506071"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { formatNumberToThousands } from '@/utils'
import { queryCabinAllowance } from '@/api/booking/cabinAllowanceQuery'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'

export default {
  name: 'CabinAllowanceQuery',
  components: { cargoAgGridWrapper, searchItem },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
          field: 'serviceProduct',
          colId: 'serviceProduct',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirServiceProduct, 'productId', params.value, 'productName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineProductCode'),
          field: 'airlineProductUuid',
          colId: 'airlineProductUuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.getAirLineProductLabelFunc(params.value, this.airlineProductDownList)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_FlightDate'), field: 'flightDate', width: 180, colId: 'flightDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          field: 'portOfDeparture',
          colId: 'portOfDeparture',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_BaseWeight'),
          colId: 'basicWeight',
          field: 'basicWeight',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LimitWeight'),
          colId: 'limitWeight',
          field: 'limitWeight',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SellableSpace'),
          colId: 'availableCabinSpace',
          field: 'availableCabinSpace',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SoldSlots'),
          colId: 'weightAssembly',
          field: 'weightAssembly',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemainingSlots'),
          colId: 'weightNotAssembly',
          field: 'weightNotAssembly',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TheoreticalVolume'),
          colId: 'theoryVolume',
          field: 'theoryVolume',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SellableVolume'),
          colId: 'sellableVolume',
          field: 'sellableVolume',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SoldVolume'),
          colId: 'cubageAssembly',
          field: 'cubageAssembly',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemainingVolume'),
          colId: 'cubageNotAssembly',
          field: 'cubageNotAssembly',
          width: 100,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true))
        }
      ],
      rowData: [],
      selectedRows: [],
      gridApi: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      airlineProductDownList: [], // 航线产品 下拉
      customSearchItems: [] // 自定义高级查询项
    }
  },
  async created() {
    // 初始化 航线产品下拉列表
    await queryAirlineProductDownList({ containVoyage: false, branchId: this.$store.getters.currentOfficeId }).then(res => {
      this.airlineProductDownList = res.data
    })
    // 初始化 静态高级查询
    this.initCustomSearchItems()
    this.queryHandler()
  },
  methods: {
    async initCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airlineProductFlight.AIRLINE_PRODUCT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_AirlineProductCode'
      searchField.itemValue = []
      searchField.tagName = 'name'
      searchField.tagValue = 'uuid'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.airlineProductDownList
      defaultSearchFields.push(searchField.formatObj2Json())
      this.customSearchItems = defaultSearchFields
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryCabinAllowance(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .input-label {
    display: inline-block;
    width: 60px;
    color: #666666;
  }
  .el-form{
    /deep/ .el-input__inner{
      width: 300px;
    }
  }
</style>
